/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PaymentsProviderSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('PAYMENTS_PROVIDER')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ parsers.exactly('paddle', 'stripe')),
    ],
]);
export class PaymentsProviderSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PaymentsProviderSettingParser.decode(input).map(res => new PaymentsProviderSetting(res));
    }
    static unsafeDecode(input) {
        return PaymentsProviderSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PaymentsProviderSettingParser.encode(data);
    }
    static schema() {
        return PaymentsProviderSettingParser.schema();
    }
}
